import _ from 'lodash'
import { useMemo } from 'react'

import { IApiDataType } from '../../types'
import buildMetricValuesHook from '../utils/buildMetricValuesHook'

export const fwWingstopListStorePerformanceKpisConfigs = {
  netSales: 'price',
  netSalesPercentageDiffToLastYear: 'percent',
  checkCount: 'number',
  checkAverage: 'price',
  actualFoodCostPercentage: 'percent',
} as const

const useCommonStorePerformanceKpis = buildMetricValuesHook({
  groupFilterType: 'store',
  metrics: {
    codes: [
      'net_sales',
      'net_sales_percentage_diff_to_last_year',
      'check_count',
      'check_average',
      'actual_food_cost_percentage',
    ],
  },
})

const useListStorePerformanceKpis = () => {
  const { data: metricsData, loading: metricLoading } =
    useCommonStorePerformanceKpis()

  return {
    data: useMemo((): IApiDataType => {
      if (!metricsData) return null

      return metricsData
    }, [metricsData]),
    loading: metricLoading,
  }
}

export default useListStorePerformanceKpis
